import { withRouter } from 'next/router'
import { forwardRef } from 'react'

const withRouterForwardRef: any = (Component) => {
	const WithRouter: any = withRouter<any>(({ forwardedRef, ...props }) => (
		<Component ref={forwardedRef} {...props} />
	))

	// eslint-disable-next-line react/display-name
	return forwardRef((props, ref) => (
		<WithRouter {...props} forwardedRef={ref} />
	))
}

export default withRouterForwardRef
